// apicore
import { APICore } from '../../helpers/api/apiCore';
import {
    DashboardMainInfo as DashboardMainInfoDataType,
    ReportReadyList as ReportReadyListDataType,
    PatientList as PatientListDataType,
    DashboardCategorySales as DashboardCategorySalesDataType,
    DashboardCategoryYearlySales,
} from 'src/types/dashboard';
// constants
import { DashboardActionTypes } from './constants';

const api = new APICore();

const INIT_STATE = {
    dashboardMain: [],
    reportReadyList: [],
    patientList: [],
    categorySales: [],
    categoryYearlySales: [],
    loading: false,
};

type DashboardActionType = {
    type:
        | DashboardActionTypes.API_RESPONSE_SUCCESS
        | DashboardActionTypes.API_RESPONSE_ERROR
        | DashboardActionTypes.GET_DASHBOARD_MAIN
        | DashboardActionTypes.GET_REPORT_READY
        | DashboardActionTypes.GET_PATIENT_LIST
        | DashboardActionTypes.GET_CATEGORY_SALES
        | DashboardActionTypes.GET_CATEGORY_YEARLY_SALES
        | DashboardActionTypes.RESET
        | DashboardActionTypes.RESET_SUCCESS
        | DashboardActionTypes.RESET_ERROR;
    payload: {
        actionType?: string;
        data?: DashboardMainInfoDataType[] | ReportReadyListDataType[] | [];
        error?: string | boolean;
        message?: string;
        code?: number;
        success?: boolean;
    };
};

type State = {
    dashboardMain?: DashboardMainInfoDataType[] | [];
    reportReadyList?: ReportReadyListDataType[] | [];
    patientList?: PatientListDataType[] | [];
    categorySales?: DashboardCategorySalesDataType[] | [];
    categoryYearlySales?: DashboardCategoryYearlySales[] | [];
    loading?: boolean;
    value?: boolean;
};

const Dashboard = (state: State = INIT_STATE, action: DashboardActionType): any => {
    switch (action.type) {
        case DashboardActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case DashboardActionTypes.GET_DASHBOARD_MAIN: {
                    return {
                        ...state,
                        dashboardMain: action.payload.data,
                        loading: false,
                    };
                }
                case DashboardActionTypes.GET_CATEGORY_SALES: {
                    return {
                        ...state,
                        categorySales: action.payload.data,
                        loading: false,
                    };
                }
                case DashboardActionTypes.GET_CATEGORY_YEARLY_SALES: {
                    return {
                        ...state,
                        categoryYearlySales: action.payload.data,
                        loading: false,
                    };
                }
                case DashboardActionTypes.GET_REPORT_READY: {
                    return {
                        ...state,
                        reportReadyList: action.payload.data,
                        loading: false,
                    };
                }
                case DashboardActionTypes.GET_PATIENT_LIST: {
                    return {
                        ...state,
                        patientList: action.payload.data,
                        loading: false,
                    };
                }
                default:
                    return { ...state };
            }

        case DashboardActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case DashboardActionTypes.GET_DASHBOARD_MAIN: {
                    return {
                        ...state,
                        message: action.payload.message,
                        code: action.payload.code,
                        loading: false,
                        success: action.payload.success,
                        error: action.payload.error,
                    };
                }
                case DashboardActionTypes.GET_CATEGORY_SALES: {
                    return {
                        ...state,
                        message: action.payload.message,
                        code: action.payload.code,
                        loading: false,
                        success: action.payload.success,
                        error: action.payload.error,
                    };
                }
                case DashboardActionTypes.GET_CATEGORY_YEARLY_SALES: {
                    return {
                        ...state,
                        message: action.payload.message,
                        code: action.payload.code,
                        loading: false,
                        success: action.payload.success,
                        error: action.payload.error,
                    };
                }
                case DashboardActionTypes.GET_REPORT_READY: {
                    return {
                        ...state,
                        message: action.payload.message,
                        code: action.payload.code,
                        loading: false,
                        success: action.payload.success,
                        error: action.payload.error,
                    };
                }
                case DashboardActionTypes.GET_PATIENT_LIST: {
                    return {
                        ...state,
                        message: action.payload.message,
                        code: action.payload.code,
                        loading: false,
                        success: action.payload.success,
                        error: action.payload.error,
                    };
                }
                default:
                    return { ...state };
            }

        case DashboardActionTypes.GET_DASHBOARD_MAIN:
            return { ...state, loading: true };
        case DashboardActionTypes.GET_CATEGORY_SALES:
            return { ...state, loading: true };
        case DashboardActionTypes.GET_CATEGORY_YEARLY_SALES:
            return { ...state, loading: true };
        case DashboardActionTypes.GET_REPORT_READY:
            return { ...state, loading: true };
        case DashboardActionTypes.GET_PATIENT_LIST:
            return { ...state, loading: true };
        case DashboardActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                message: '',
                actionType: 'reset',
            };
        case DashboardActionTypes.RESET_SUCCESS:
            return {
                ...state,
                loading: false,
                success: false,
                message: '',
                actionType: 'resetSuccess',
            };
        case DashboardActionTypes.RESET_ERROR:
            return {
                ...state,
                loading: false,
                error: false,
                message: '',
                actionType: 'resetError',
            };
        default:
            return { ...state };
    }
};

export default Dashboard;
